import { render, staticRenderFns } from "./CaseQuestions.vue?vue&type=template&id=fc5ed10c&scoped=true&"
import script from "./CaseQuestions.vue?vue&type=script&lang=js&"
export * from "./CaseQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CaseQuestions.vue?vue&type=style&index=0&id=fc5ed10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5ed10c",
  null
  
)

export default component.exports